import React from 'react';
import authService from './authService';

export default () => {
  authService
    .authFetch(authService.BASE_URL + '/api/v1/identities')
    .then(result => console.log('Request', result));
  return <> </>;
};
